module.exports = __webpack_public_path__ + "static/media/86.baa02be7.jpg";